<template>
  <BaseElForm ref="form" :model="formData" :rules="formRules" label-position="top">
    <BaseElFormItem label="會員類別" prop="isMember">
      <BaseElRadioGroup v-model="formData.isMember" testName="formData_isMember" @change="changeIsMember">
        <BaseElRadio v-if="!disabledMemberReservation" :label="true">會員</BaseElRadio>
        <BaseElRadio :label="false">非會員</BaseElRadio>
      </BaseElRadioGroup>
    </BaseElFormItem>
    <BaseElFormItem v-if="config.reservation.allowOrderMorePeople" label="預約人數">
      <template slot="label">
        <div class="flex items-center" style="gap: 8px">
          <p>預約人數 <span v-if="checkAction('admin.resourceItem.page')" class="text-sub text-gray-60">(超過 1 人的預約，僅提供「純人員服務」)</span></p>
        </div>
      </template>
      <BaseElInputNumber
        v-model="formData.peopleCount"
        testName="formData_peopleCount"
        :min="1"
        :max="config.reservation.maxOrderMorePeopleCount"
      />
    </BaseElFormItem>
    <BaseElFormItem v-if="formData.isMember" label="會員" prop="member">
      <MemberSearch
        testName="formData_member"
        :model.sync="formData.member"
        @change="onMemberChange"
      />
      <p v-if="memberStatusError" class="text-danger text-sm mt-1">{{ memberStatusError }}</p>
      <p v-if="memberStatusWarning" class="text-warning text-sm mt-1">{{ memberStatusWarning }}</p>
    </BaseElFormItem>

    <div v-if="!formData.isMember">
      <BaseElFormItem label="姓名" prop="name">
        <BaseElInput
          v-model="formData.name"
          testName="formData_guest_name"
          clearable
          placeholder="請輸入姓名"
        />
      </BaseElFormItem>
      <BaseElFormItem label="電話號碼" prop="phone">
        <BaseElInput
          v-model="formData.phone"
          testName="formData_guest_phone"
          clearable
          placeholder="請輸入電話號碼"
        />
      </BaseElFormItem>
    </div>
  </BaseElForm>
</template>

<script>
import MemberSearch from '@/components/Search/MemberSearch.vue'
import { noEmptyRules, phoneRules } from '@/validation'
import { FindMember } from '@/api/member'
import { get, isEmpty } from 'lodash'
import { usePermissions } from '@/use/permissions'
import store from '@/store'
import { useRoute } from 'vue-router/composables'
import { computed, onMounted, reactive, ref, watch, nextTick } from 'vue'
import { useShop } from '@/use/shop'

export default {
  name: 'MemberInfo',
  components: {
    MemberSearch,
  },
  props: {
    config: {
      type: Object,
      default: () => ({
        allowOtherReservation: false,
      }),
    },
    memberClassTickets: {
      type: Array,
      default: () => ([]),
    },
    reservation: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const { shopId } = useShop()
    const route = useRoute()
    const fixedMember = computed(() => route.query.member)
    const { checkAction } = usePermissions()
    const form = ref(null)
    const formData = reactive({
      isMember: true,
      member: null,
      peopleCount: 1,
      name: null,
      phone: null,
    })
    const formRules = reactive({
      isMember: [noEmptyRules()],
      member: [noEmptyRules()],
      name: [noEmptyRules()],
      phone: [noEmptyRules(), phoneRules()],
    })

    // adminView.appointmentOrder.createDisableMember
    const disabledMemberReservation = computed(() => {
      return checkAction('adminView.appointmentOrder.createDisableMember')
    })

    watch(() => props.reservation, async () => {
      await syncData()
    })
    watch(formData, (data) => {
      emit('update', data)
    }, { deep: true })

    const syncData = async () => {
      if (!isEmpty(props.reservation)) {
        const member = get(props.reservation, 'Member')
        const memberPhone = get(member, 'UserInfo.phone')
        const memberName = get(member, 'UserInfo.name')
        const userName = get(props.reservation, 'userName')
        const userPhone = get(props.reservation, 'userPhone')
        if (!member || memberPhone !== userPhone || memberName !== userName) {
          formData.isMember = false
          formData.name = userName
          formData.phone = userPhone
        }
      }
      if (disabledMemberReservation.value) {
        formData.isMember = false
        formData.name = null
        formData.phone = null
      }
    }
    const memberStatusError = ref('')
    const memberStatusWarning = ref('')

    const onMemberChange = async (member) => {
      memberStatusError.value = ''
      memberStatusWarning.value = ''
      if (!member) return

      // 檢查會員狀態
      const status = member.memberStatus || (member.isBlock ? 'blocked' : 'normal')
      if (status === 'blocked') {
        memberStatusError.value = '此會員為黑名單會員，無法從後台進行預約'
        formData.member = null
        return
      }
      if (status === 'warning') {
        memberStatusWarning.value = '此會員為警告會員'
      }

      console.log('🚩onMemberChange')
      await store.dispatch('reservationCreate/getMebmerData', member.id)
      console.log('🚩getMebmerData', store.state.reservationCreate.memberData)
      emit('memberChange', store.state.reservationCreate.memberData)
    }
    const findMember = async (memberId) => {
      if (!memberId) return
      try {
        const member = await FindMember({
          shopId: shopId.value,
          id: memberId,
        })
        formData.member = member
      } catch (e) {
        window.$message.error(e.message)
      }
    }
    const changeIsMember = (isMember) => {
      if (!isMember) formData.member = null
      if (isMember) {
        formData.name = null
        formData.phone = null
      }
    }
    onMounted(async () => {
      await nextTick()
      emit('ref', form.value)
      if (fixedMember.value) {
        console.log('🚩fixedMember')
        await findMember(fixedMember.value)
        onMemberChange(formData.member)
        store.dispatch('reservationCreate/getMebmerData', fixedMember.value)
      }
      await syncData()
    })

    return { onMemberChange, checkAction, fixedMember, formData, formRules, changeIsMember, form, disabledMemberReservation, memberStatusError, memberStatusWarning }
  },
}
</script>

<style scoped lang="postcss">
</style>
